module.exports = __webpack_public_path__ + "static/home-right-column-vector-2f221e8fe89b24bedb5c08788aab1892.png";